import { ThemeOptions } from '@mui/material/styles';
import { defaultTheme } from './default';

/**
 * Custom Theme
 * Allows for customer-specific overrides
 * By default, inherits from the default theme
 */
export const customTheme: ThemeOptions = {
    ...defaultTheme,
    // Add customer-specific overrides here
    // Example:
    // palette: {
    //     ...defaultTheme.palette,
    //     primary: {
    //         main: '#custom-color',
    //     },
    // },
};
